import { CircularProgress, Grid, Typography } from "@mui/material";
import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrumbs from "../../components/BreadCrumb";
import { LeftSidebar as NavFrame } from "layout-blueprints";
import { setSnackbar } from "../../modules/snackbar/api/snackbar";
import {
  getByUuid,
  updateVendor,
} from "../../modules/vendor/api/actions";
import VendorTabbedSections from "./VendorTabbedSections";

const IndividualVendorPage = () => {
  const { uuid } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const vendor = useSelector((state) => state.vendors.data.vendor);
  const loading = useSelector((state) => state.vendors.isLoading);

  const fetchVendor = useCallback(() =>
    dispatch(getByUuid(uuid)).catch(() => {
      dispatch(setSnackbar(true, "error", "Failed to fetch vendor."));
      navigate("/vendors");
    }), [dispatch, navigate, uuid]);

  useEffect(() => {
    fetchVendor();
  }, [fetchVendor]);

  useEffect(() => {
    if (vendor) {
      document.title = `Ubil+ Vendor - ${vendor.name}`;
    }
  }, [vendor]);

  const submitVendorEdit = async (originalVendorObj, editVendorObj) => {
    try {
      await dispatch(updateVendor(originalVendorObj.uuid, editVendorObj));
      dispatch(setSnackbar(true, "success", "Successfully edited vendor."));
      return true;
    } catch (err) {
      dispatch(setSnackbar(true, "error", "Failed to edit vendor."));
      return false;
    }
  };

  if (loading || (vendor && vendor.uuid !== uuid)) {
    return (
      <NavFrame>
        <Grid container justify="center" style={{ marginTop: 48 }}>
          <CircularProgress />
        </Grid>
      </NavFrame>
    );
  }

  if (!vendor) {
    return null;
  }

  return (
    <NavFrame>
      <Grid container direction="column" spacing={2}>
        <Grid container item direction="column" xs={12}>
          <Grid container>
            <Grid item container direction="row" xs={12} justify="space-between">
              <Grid item xs={12} sm={12} md={8}>
                <Typography variant="h4" gutterBottom>
                  {vendor.name}
                </Typography>
                <Typography variant="subtitle1" color="textSecondary">
                  Vendor #{vendor.vendorNum} · {vendor.status}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Breadcrumbs current="Vendors" />
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <VendorTabbedSections
            vendor={vendor}
            submitVendorEdit={submitVendorEdit}
            onSaveSuccess={fetchVendor}
          />
        </Grid>
      </Grid>
    </NavFrame>
  );
};

export default IndividualVendorPage;
